import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { find } from 'lodash'
import Operations from '../../../operations'
import Actions from '../../../actions'
import { filter, isEqual } from 'lodash'
import Swal from 'sweetalert2'
import { colors, sizes } from '@lmc/common/constants'
import Form from '../../../components/forms'
import { isBrowser, isTablet } from 'react-device-detect'
import {
  AccessRestriction,
  SectionHeader,
  HelpLink,
  Spinner,
} from '../../../components/generic'
import FamilyPortalPaywall from './FamilyPortalPaywall'
import {
  FamilyFeaturesSettings,
  FamilyLogDetailsSettings,
  FamilyLogViewSettings,
} from './components'
import Glyph from '../../../LEGACY/Glyph'
import { Button } from '@lmc/ui-kit'
import { showToast } from 'common/utils'

export class FamilySettingsScreen extends Component {
  state = {
    saveButtonTitle: 'Save Changes',
  }

  componentDidMount() {
    const { addForm, homeSettings } = this.props
    addForm(homeSettings)
  }

  componentWillUnmount() {
    this.props.remove({})
  }

  componentDidUpdate(prevProps) {
    const { fields, setHomeDetails } = this.props
    if (prevProps.fields && !isEqual(prevProps.fields, fields)) {
      for (const key in fields) {
        if (fields[key] !== prevProps.fields[key]) {
          setHomeDetails({
            key,
            value: fields[key],
          })
        }
      }
    }
  }

  onClickHandler = () => {
    const { homeSettings, refreshLists, saveSettings, clear } = this.props
    showToast({ title: 'Saved' })
    saveSettings(homeSettings)
    refreshLists()
    clear()
    this.showSwal()
  }

  showSwal() {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top',
      showConfirmButton: false,
      timer: 2000,
    })
    return Toast.fire({
      icon: 'success',
      title: 'Saved',
    })
  }

  renderCustomisationTitleSection = () => (
    <div style={styles.customisationTitleContainer}>
      <SectionHeader title={CUSTOMISATION_TITLE} />
      <div style={styles.preferredSubTitle}>
        {CUSTOMISATION_SUBTITLE}
        <HelpLink supportLink={HELP_ARTICLE_URL} />
      </div>
    </div>
  )

  renderQuickLogSettings = () => {
    const { homeSettings } = this.props

    return (
      <div>
        <FamilyLogDetailsSettings
          homeSettings={homeSettings}
          formId="family-settings"
        />
        <FamilyLogViewSettings
          homeSettings={homeSettings}
          formId="family-settings"
        />
      </div>
    )
  }

  render() {
    const { homeSettings, openModal } = this.props
    const { saveButtonTitle } = this.state
    const { familyPaymentType } = homeSettings

    if (!homeSettings) return null

    if (!familyPaymentType) return <Spinner />

    const displayPaywall = !homeSettings.familySetupComplete

    return (
      <div style={styles.container}>
        {this.renderCustomisationTitleSection()}
        {displayPaywall ? (
          <FamilyPortalPaywall
            openModal={() => {
              window.scrollTo(0, 0)
              openModal()
            }}
            activeResidents={homeSettings.activeResidents}
            preferredPeopleNominative={homeSettings.preferredPeopleNominative}
          />
        ) : null}
        {!displayPaywall ? (
          <FamilyFeaturesSettings
            homeSettings={homeSettings}
            formId="family-settings"
            preferredCarePlansNominative={
              homeSettings.preferredCarePlansNominative
            }
          />
        ) : null}
        {!displayPaywall ? this.renderQuickLogSettings() : null}
        {!displayPaywall ? (
          <AccessRestriction>
            <div
              className="lmc-fixed-footer"
              style={{
                ...styles.footer,
              }}
            >
              <Button
                variant="primary"
                onClick={this.onClickHandler}
                icon={<Glyph name="check" />}
              >
                {saveButtonTitle}
              </Button>
            </div>
          </AccessRestriction>
        ) : null}
      </div>
    )
  }
}

const FORM_ID = 'family-settings'
const CUSTOMISATION_TITLE = 'Family Portal Customisation'
const CUSTOMISATION_SUBTITLE =
  'Customise what families will be able to view in the Family Portal. These changes will be applied to all family members using the Family Portal. '
const HELP_ARTICLE_URL =
  'https://support.logmycare.co.uk/en/articles/4248185-how-can-i-customise-the-family-portal'

FamilySettingsScreen.propTypes = {
  homeSettings: PropTypes.object,
  openModal: PropTypes.func,
}

const isDesktop = isBrowser || isTablet

const styles = {
  appPrivacyImg: {
    paddingTop: 10,
  },
  billingSectionContainer: {
    marginBottom: 61,
  },
  buttonGreen: {
    background: colors.successgreen,
    color: 'white',
    padding: '0px 25px',
    marginLeft: 10,
    textShadow: 'none',
  },
  buttonGray: {
    background: colors.gray,
    color: 'white',
    padding: '0px 25px',
    marginLeft: 10,
    textShadow: 'none',
  },
  container: {
    margin: '0 auto',
    maxWidth: sizes.childScreen,
    padding: '24px 24px',
  },
  customisationTitleContainer: {
    marginBottom: 25,
  },
  featureOptionsContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingTop: 8,
  },
  footer: {
    border: 'none',
    background: 'white',
    display: 'flex',
    justifyContent: isDesktop ? 'flex-end' : 'space-between',
    width: isBrowser || isTablet ? 'calc(100vw - 290px)' : '100vw',
  },
  paymentOptionMask: {
    height: 40,
    position: 'relative',
    marginBottom: -40,
    zIndex: 10,
  },
  preferredSubTitle: {
    color: colors.black,
    display: 'block',
    marginTop: 16,
    lineHeight: '22px',
  },
  sectionContainer: {
    marginTop: 35,
    marginBottom: 15,
  },
}

const mapStateToProps = (state) => {
  const {
    familyLogCategoryItems,
    familyCarePlans,
    familyDocuments,
    familyMedications,
    familyPaymentType,
    familySetupComplete,
    familyShowNames,
    familyShowDates,
    carePlans,
    id,
    family,
    preferredCarePlansNominative,
    preferredPeopleNominative,
    pro,
  } = state.global.home

  const activeResidents = find(state.data.homes, { id })?.activeResidents
    ? find(state.data.homes, { id }).activeResidents
    : state.data.residents
    ? filter(state.data.residents, { status: 'active' }).length
    : null

  return {
    homeSettings: {
      familyLogCategoryItems,
      familyCarePlans,
      familyDocuments,
      familyMedications,
      familyPaymentType,
      familySetupComplete,
      familyShowNames,
      familyShowDates,
      carePlans,
      id,
      family,
      activeResidents,
      preferredCarePlansNominative,
      preferredPeopleNominative,
      pro,
    },
  }
}

const mapDispatchToProps = (dispatch) => ({
  setHomeDetails: ({ key, value }) =>
    dispatch(Actions.setHomeDetails({ key, value })),
  getHomeDetails: (homeSettings) => {
    dispatch(Operations.getHomeDetails(homeSettings.id))
  },
  openModal: () => {
    dispatch(Operations.openModal({ modalId: 'setupFamilyPortal' }))
    // Initialise the form with data
    dispatch(
      Actions.addForm({
        formId: 'setupFamilyPortal',
        initial: {
          // CARE-1368: Setting the default values
          familyLogCategoryItems: [
            '5e81db67b1b4e673bc2bb8de',
            '5e81db67b1b4e673bc2bb8c9',
            '5e81db67b1b4e673bc2bb8dd',
            '5e81db67b1b4e673bc2bb8cb',
            '5e81db67b1b4e673bc2bb8e7',
            '5e81db67b1b4e673bc2bb8e0',
            '5e81db67b1b4e673bc2bb8df',
            '5ef08711bf3af7d66bf6d68e',
            '5e81db67b1b4e673bc2bb8f9',
            '5e81db67b1b4e673bc2bb8f6',
            '5f5f63eaf8815e77438e76da',
          ],
          familyCarePlans: false,
          familyDocuments: true,
          familyShowNames: false,
          familyShowDates: true,
          familyMedications: false,
          familyPaymentType: 'home',
        },
      })
    )
  },
  refreshLists: () => dispatch(Operations.loadList('log-category-items')),
  saveSettings: (homeSettings) =>
    dispatch(dispatch(Operations.saveHomeDetails(homeSettings))),
})

const wrappedForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(FamilySettingsScreen)

export default Form(wrappedForm, FORM_ID)
